const PIN_SESSION_KEY = 'securityPinEnteredAlready';
const PIN_TOKEN_SECRET = 'myvw-pin-management';

export function setUserSecurityPinBooleanToSessionStorage(): void {
  const payload = btoa('pin_verified');
  const sig = btoa('pin_verified' + PIN_TOKEN_SECRET);
  sessionStorage.setItem(PIN_SESSION_KEY, `${payload}.${sig}`);
}

export function getUserSecurityPinBooleanFromSessionStorage(): boolean {
  try {
    const raw = sessionStorage.getItem(PIN_SESSION_KEY);
    if (!raw) return false;
    const [encodedPayload, sig] = raw.split('.');
    if (!encodedPayload || !sig) return false;
    const payload = atob(encodedPayload);
    const expectedSig = btoa(payload + PIN_TOKEN_SECRET);
    return sig === expectedSig;
  } catch {
    return false;
  }
}

export function removeSetUserSecurityPinBooleanToSessionStorage(): void {
  sessionStorage.removeItem(PIN_SESSION_KEY);
}
